import React from 'react';
import './styles.css';

function Card({ title, icon, boxBgColor, color, value }) {
  const fontSize = `${22 - (value.toString().length - 1) * 2}px`;

  return (
    <div className={`card box-wrapper box-pd ${boxBgColor}`}>
      {icon ? (
        <div className="box-header-icon">
          <div className={`bt-icon-list ${icon}`} />
        </div>
      ) : null}

      <div className="text-container label-text text-center ">{title}</div>
      <div
        className={`box-circle ${color}`}
        style={{
          fontSize,
        }}
      >
        {value}
      </div>
    </div>
  );
}

export default Card;
